import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table'
import useToken from '../../App/useToken';
import './LandingPage.css'

export default function LandingPage() {
  const [isLoading, setIsLoading] = useState(true);
  const { getUser } = useToken();
  const [listitems, setListitems] = useState([]);

  useEffect(() => {
    async function checkLandingPage() {
      const rawUser = getUser();
      if (rawUser) {
        const user = JSON.parse(rawUser);
        switch (user.role) {
          case 'admin':
            window.location.href = '/majorcourses';
            setIsLoading(false);
            break;
          case 'adminUnit':
            window.location.href = '/majorcourses';
            setIsLoading(false);
            break;
          case 'student':
            window.location.href = `students/${user._id}/edit`;
            setIsLoading(false);
            break;
        
          default:
            setIsLoading(false);
            break;
        }  
      }
    }
    checkLandingPage();
    //getCourse()
  }, []);
  
  

  return(
    <div className="course-list">
      {isLoading && <div clalssname="container">
        <a 
          className="btn btn-outline-success btn-sm btn-creat-course" 
          href="/course/create"
        >
          เพิ่มหลักสูตร
        </a>
        <br />
        <Table striped  hover style={{ width: '80rem' }}>
          <thead>
            <tr>
              <th style={{ width: '5%' }}>#</th>
              <th style={{ width: '75%' }}>ชื่อหลักสูตร(ชื่อ/ปี/รุ่น)</th>
              <th style={{ width: '10%', textAlign: 'end' }}>จำนวนที่รับ</th>
              <th style={{ width: '10%', textAlign: 'end' }}>จำนวนผู้มีสิทธิ์</th>
            </tr>
          </thead>
          <tbody>
            {(listitems !== []) && listitems.map((listitem, index) => (
              <tr key={listitem._id} onClick={() => {window.location.href = `/course/${listitem._id}`}}>
                <td>{index + 1}</td>
                <td>{listitem.name}</td>
                <td style={{ textAlign: 'end' }}>{listitem.amount}</td>
                <td style={{ textAlign: 'end' }}>{listitem.user_courses.length}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>}
    </div>
  )
}
